import { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import { FormControlLabel, Radio } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import routes from "routes";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function SignUpBasic() {
  const [isTrainingCompanyChecked, setIsTrainingCompanyChecked] = useState(false);
  const [isTrainerChecked, setIsTrainerChecked] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [buttonText, setButtonText] = useState("Create Account");

  const handleTrainingComapanyCheckboxChange = (event) => {
    setIsTrainingCompanyChecked(event.target.checked);
    setIsButtonEnabled(event.target.checked);
    setButtonText(event.target.checked ? "Join as a Training Partner" : "Create Account");
    setIsTrainerChecked(false);
  };

  const handleTrainerCheckboxChange = (event) => {
    setIsTrainerChecked(event.target.checked);
    setIsButtonEnabled(event.target.checked);
    setButtonText(event.target.checked ? "Join as a Trainer" : "Create Account");
    setIsTrainingCompanyChecked(false);
  };

  const navigate = useNavigate();

  function handleButtonClick() {
    if (isTrainingCompanyChecked) {
      // window.location.href = '/app/trainingcompany';
      navigate(`/app/trainingcompany`);
      console.log("hhhhiiii");
    } else if (isTrainerChecked) {
      // window.location.href = '/app/trainer';
      navigate(`/app/trainer`);
      console.log("jijijij");
    }
  }

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={7}>
            <Card>
              <MKBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Join as a Training Partner or Trainer
                </MKTypography>
              </MKBox>
              <MKBox my={4} px={3}>
                <MKBox component="form" role="form">
                  <Grid container spacing={1} alignItems="center" direction="column">
                    <Grid item xs={12} sm={6}>
                      <div style={{ textAlign: "center" }}>
                        <img src="https://visme.co/blog/wp-content/uploads/2019/10/animated-presentation-software-header-wide.gif" alt="Training" width="800" height="200" />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} container justifyContent="center">
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Radio
                              checked={isTrainingCompanyChecked}
                              onChange={handleTrainingComapanyCheckboxChange}
                              style={{ marginLeft: "40px" }}
                            />
                          }
                          label={
                            <div>
                              <span>I am a Training Partner, seeking Trainers.</span>
                            </div>
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Radio
                              checked={isTrainerChecked}
                              onChange={handleTrainerCheckboxChange}
                              style={{ marginLeft: "40px" }}
                            />
                          }
                          label={
                            <div>
                              <span>I am a Trainer, eager to provide trainings.</span>
                            </div>
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <MKBox mt={4} mb={1}>
                    <MKButton disabled={!isButtonEnabled} type="submit" variant="gradient" color="info" fullWidth
                      onClick={() => handleButtonClick()}
                    >
                      {buttonText}
                    </MKButton>
                  </MKBox>
                </MKBox>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
      <MKBox width="100%" position="absolute" zIndex={2} bottom="1.625rem">
        <SimpleFooter light />
      </MKBox>
    </>
  );
}

export default SignUpBasic;